<template>
  <div class="feedback-chips">
    <div class="feedback-chips-header">
      <div class="feedback-chips-title">
        <h2>
          <template v-if="chipData.type === 'Need'">
            Needs
          </template><template v-else>
            Wants
          </template> Match
        </h2>
        <span>Select the <template v-if="chipData.type === 'Need'">needs</template><template v-else>wants</template> to the home matched</span>
      </div>
      <feedback-pref-circle class="needs-want-feedback-circle" :pref-data="pref" :colors="colors" />
    </div>
    <div class="feedback-chips-content">
      <v-layout wrap class="mt-md-3">
        <v-flex
          :key="chipData.type"
          :class="chipData.class"
        >
          <feedback-pref-chips
            v-if="chipData.data"
            :pref-chips-data="chipData"
            :colors="colors"
            @pref-toggle="$emit('pref-toggle', $event)"
          />
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import FeedbackPrefCircle from '../common/feedback-modal/FeedbackPrefCircle.vue'
import FeedbackPrefChips from '../common/feedback-modal/FeedbackPrefChips.vue'
import colors from '../../scss/_colors.scss'

export default {
  components: {
    FeedbackPrefCircle,
    FeedbackPrefChips
  },
  props: {
    chipData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      tabs: ['Needs', 'Wants', 'Pics', 'Notes'],
      colors
    }
  },
  computed: {
    pref() {
      const data = this.chipData && this.chipData.data ? this.chipData.data : []
      const type = this.chipData.type === 'Need' ? {
        type: 'Need',
        match: data.filter(item => item.match).length,
        total: data.length,
        color: this.colors.hwayzTapestry
      } : {
        type: 'Want',
        match: data.filter(item => item.match).length,
        total: data.length,
        color: this.colors.hwayzDarkenGreen
      }
      return type
    }
  }
}
</script>

<style lang="sass">
.feedback-chips-title
  width: 100%
  @media only screen and (max-width: 768px)
    margin-bottom: 20px
  h2
    font-size: 20px
    line-height: 37px
    font-weight: 400
    text-transform: capitalize
    color: #373737
    margin-bottom: 10px
  span
    font-size: 16px
    line-height: 20px
    color: #373737
.feedback-chips-header
  display: flex
  margin-bottom: 60px
  justify-content: center
  position: relative
  align-items: center
  @media only screen and (max-width: 768px)
    flex-direction: column
    margin-bottom: 15px
    .needs-want-feedback-circle
      padding-top: 15px
.needs-want-feedback-circle
  position: absolute
  left: 70%
  top: 10px
  .v-progress-circular
    width: 48px !important
    height: 48px !important
  .pref-percent
    margin-left: 10px
  .pref-percent h3
    font-size: 24px
    line-height: 1
  @media only screen and (max-width: 768px)
    right: 20px
    position: static
.feedback-chips-content .chips-container
  justify-content: center
.feedback-chips-content .chips-container:after
   content: none
</style>
